import * as angular from "angular";
import {IController} from "angular";

export class RelationStatusesMultiSelectCtrl implements IController {

  selectedStatuses: any;
  noUnderline: boolean;
  ngPlaceholder: string;
  onChange: Function;

  public statuses;

  constructor(private $mdSelect, private $log) {
  }

  $onInit() {
    this.statuses = ['Pending', 'Scheduled', 'Dispatched', 'Completed', 'Canceled'];

  }

  private reset() {
    this.onChange({statuses: undefined});
    this.$mdSelect.hide();
  }

  private cancel() {
    this.$mdSelect.hide();
  }

  private select() {
    this.onChange({statuses: this.selectedStatuses});
    this.$mdSelect.hide();
  }

}

angular
  .module('bringoz.admin.planning')
  .component('relationStatusesMultiSelect', {
    bindings: {
      selectedStatuses: '<',
      noUnderline: '@?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./planning-relation-statuses-multi-select.html').default,
    controller: RelationStatusesMultiSelectCtrl
  });
